import { CIMSPage, isDeleted } from 'shared'
import {
  ConcreteTestSet as CTS,
  ConcreteTestBreakData as TestBreakData,
  ConcreteCoreBreakData as CoreBreakData,
} from 'schema'
import { DeepLinksCIMSBasicField } from 'components/CIMSBasicFields/hooks/useItemCallback/components/LinksSpaceCIMSBasicField/types'

export function breakDataTags<
  T extends {
    id: string | number
    name: string
    concreteCoreBreakDatas: ConcreteCoreBreakData[]
    concreteTestBreakDatas: ConcreteTestBreakData[]
  }
>({
  id,
  name,
  concreteCoreBreakDatas,
  concreteTestBreakDatas,
}: T): DeepLinksCIMSBasicField {
  const testSets = [
    ...concreteCoreBreakDatas,
    ...concreteTestBreakDatas,
  ].reduce((map, breakData) => {
    let cts
    if (breakData.__typename === 'ConcreteCoreBreakData')
      cts =
        breakData.concreteCoreMeasurement?.concretePlacement?.concreteTestSet
    else if (breakData.__typename === 'ConcreteTestBreakData')
      cts = breakData.concreteTest.concreteTestSet
    if (!cts || !cts.globalId || !cts.testSetId) return map
    return map.set(cts.globalId, {
      testSetId: cts.testSetId,
      deleted: isDeleted(cts.deleted),
    })
  }, new Map<string, { testSetId: string; deleted: boolean }>())
  return {
    type: 'deepLinks',
    label: 'Associated Test Sets',
    help: `Concrete Test Sets where ${name} is associated with the Break Data`,
    showMore: { key: id },
    links: [...testSets.entries()].map(
      ([concreteTestSetId, { testSetId, deleted }]) => ({
        label: testSetId,
        page: CIMSPage.ConcreteTestSets,
        recordId: concreteTestSetId,
        deleted,
      })
    ),
  }
}

type ConcreteCoreBreakData = Pick<CoreBreakData, '__typename'> & {
  concreteCoreMeasurement: {
    concretePlacement?: { concreteTestSet?: ConcreteTestSet | null } | null
  }
}
type ConcreteTestBreakData = Pick<TestBreakData, '__typename'> & {
  concreteTest: { concreteTestSet?: ConcreteTestSet | null }
}
type ConcreteTestSet = Pick<
  CTS,
  '__typename' | 'globalId' | 'deleted' | 'testSetId'
>
